import React from "react";
import "../../../../style/block.scss";
import "../../../../style/feature.scss";
import "./style.scss";
import "../../../../style/buttons.scss";
import { format } from "date-fns";
import SingleExercise from "../single-exercise";
import { ExerciseScheduleList } from "../../../models/ExerciseScheduleList";
import capitalizeFirstLetter from "../../../../utils/capitalizeFirstLetter";
import LoadableComponent from "../../../../features/Loading/LoadableComponent";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";

interface IProps {
  dateFromState: Date;
  exercisesList: ExerciseScheduleList;
  loading: boolean;
  onRefreshExercises: () => void;
}

const ScheduleMobile: React.FC<IProps> = ({ dateFromState, exercisesList, loading, onRefreshExercises }) => {
  const { t } = useTranslation();
  const locale = useLocaleByLanguage();
  const getEventsOnDay = () => {
    const currentDay = capitalizeFirstLetter(
      format(dateFromState, "EEEE", { locale: locale })
    ) as keyof ExerciseScheduleList;
    return exercisesList[currentDay] || [];
  };

  const isNoData = getEventsOnDay().length === 0;

  return (
    <React.Fragment>
      <LoadableComponent loading={loading}>
        <table className="exercise-schedule-desktop">
          <thead>
            <tr>
              <th className="days">
                <span>{format(dateFromState, "cccc", { locale: locale })}</span>
                <b>{format(dateFromState, "dd.MM")}</b>
              </th>
            </tr>
          </thead>
        </table>
        <table className="exercise-schedule-desktop">
          <tbody>
            {isNoData ? (
              <>{t("brak_wydarzen_tego_dnia")}</>
            ) : (
              <>
                {Array.from({ length: 24 }).map((_, hour) => {
                  const hourEvents = getEventsOnDay().filter((e) => {
                    const eventHour = new Date(e.startTime).getHours();
                    return eventHour === hour;
                  });

                  if (hourEvents.length === 0) {
                    return null;
                  }

                  return (
                    <tr key={hour}>
                      <td>
                        {hourEvents.length > 0 ? (
                          <div>
                            {hourEvents.map((event, index) => (
                              <div className="singleone" key={index}>
                                <SingleExercise exercise={event} onRefreshExercises={onRefreshExercises} />
                              </div>
                            ))}
                          </div>
                        ) : null}
                      </td>
                    </tr>
                  );
                })}
              </>
            )}
          </tbody>
        </table>
      </LoadableComponent>
    </React.Fragment>
  );
};

export default ScheduleMobile;
